export default function (editor) {
  const richTextEditor = editor.options.get("richTextEditor");
  (function init() {
    richTextEditor.plugins["character_word_count"] = {
      renderInEditor,
      cleanUp,
      containPluginElements,
    };
  })();

  function renderInEditor() {}

  function cleanUp(content) {
    return content;
  }

  function containPluginElements() {
    return false;
  }
}
